export const ROUTE_AGENCIES = 'ROUTE_AGENCIES'
export const ROUTE_AGENCY_EDIT = 'ROUTE_AGENCY_EDIT'
export const ROUTE_AGENCY_VIEW = 'ROUTE_AGENCY_VIEW'
export const ROUTE_AGENCY_CREATE = 'ROUTE_AGENCY_CREATE'
